/**
 * AAA IDP delivery pickup person reducer
 * 
 */
import { DELETE, DELIVERY_PICKUP_PERSON, DELIVERY_PICKUP_PERSON_REQUIRED_ATTRIBUTE } from '../../actions/types';
export const initialState = {
  error: false,
  required: false,
  valid: null,
  value: ''
};
export default function (state = initialState, action) {
  switch (action.type) {
    case DELETE:
      return initialState;
    case DELIVERY_PICKUP_PERSON:
      {
        const {
          value
        } = action;
        const valid = value === 'self' || value === 'other' ? true : false;
        return {
          ...state,
          error: !valid,
          value,
          valid
        };
      }
    case DELIVERY_PICKUP_PERSON_REQUIRED_ATTRIBUTE:
      {
        const {
          required
        } = action;
        return {
          ...state,
          error: false,
          required: required,
          valid: true
        };
      }
    default:
      return state;
  }
}